export const mobileRoutesConfig = {
  // Routes allowed on mobile viewports
  allowedRoutes: [
    '/workforce/dashboard',
    '/workforce/organization',
    '/workforce/team-review',
    '/workforce/customers',
    '/workforce/profile',
    '/workforce/accounts',
    '/workforce/learning',
    '/workforce/setup',
    '/workforce/reports',
    '/workforce/batch-reports',
    '/workforce/notifications',
    '/workforce/approvals'
  ],

  // Blocker page configuration for unallowed routes
  blockerConfig: {
    title: 'Desktop Optimized Feature',
    message:
      'For the best experience, please use the desktop version of the admin portal. This page contains complex configurations and charts optimized for larger screens.',
    icon: 'mdi-monitor',
    buttonText: 'Back to Dashboard'
  },

  // Banner shown in mobile navigation menu drawer
  menuBannerText:
    'For full administrative capabilities, please access the portal via a desktop web browser.'
}

/**
 * Check if a path is allowed on mobile viewports
 * @param {string} path
 * @returns {boolean}
 */
export function isRouteAllowedOnMobile(path) {
  if (!path) return true
  // Allow login or standard open pages always
  if (path === '/login' || path.startsWith('/open/form') || path.startsWith('/google/callback')) {
    return true
  }
  return mobileRoutesConfig.allowedRoutes.some((allowedPath) => path.startsWith(allowedPath))
}
